import Vue from "vue";
import _ from "lodash";
import qs from "qs";
import moment from "moment";

const URL = "/db/trainer";
const API_URL = URL + "/api/";

const state = {
  trainer: [],
  trainer_loaded: false,
  trainer_init: true
};

const getters = {
  trainerInjected(state) {
    return _.cloneDeep(state.trainer).map(data => {
      data.total_training = data.training.length;
      // other things
      _.map(
        { total_onsite: "ON-SITE", total_offsite: "OFF-SITE" },
        (val, key) => {
          data[key] = data.training.filter(tr => {
            return tr.pel_tipe == val;
          }).length;
        }
      );
      return data;
    });
  },
  trainerByPeriode(state, getters, rootState) {
    let trainer = _.cloneDeep(state.trainer);
    return trainer.map(data => {
      data.training = data.training.filter(tr => {
        let bool = true;
        if (moment(rootState.periode$).isValid()) {
          bool = moment(tr.waktu_mulai).format("YYYY") == rootState.periode$;
        }
        return bool;
      });
      data.total_training = data.training.length;
      // other things
      _.map(
        { total_onsite: "ON-SITE", total_offsite: "OFF-SITE" },
        (val, key) => {
          data[key] = data.training.filter(tr => {
            return tr.pel_tipe == val;
          }).length;
        }
      );
      return data;
    });
  },
  trainerByLamanPeriode(state, getters, rootState) {
    let trainer = _.cloneDeep(state.trainer);
    return trainer.map(data => {
      data.training = data.training.filter(tr => {
        let bool = tr.id_laman == rootState.id_laman$;
        if (bool & moment(rootState.periode$).isValid()) {
          bool = moment(tr.waktu_mulai).format("YYYY") == rootState.periode$;
        }
        return bool;
      });
      data.total_training = data.training.length;
      // other things
      _.map(
        { total_onsite: "ON-SITE", total_offsite: "OFF-SITE" },
        (val, key) => {
          data[key] = data.training.filter(tr => {
            return tr.pel_tipe == val;
          }).length;
        }
      );
      return data;
    });
  }
};

const mutations = {
  INIT(state) {
    if (state.trainer_init) state.trainer_init = false;
  },
  LOADED(state, payload) {
    state.trainer_loaded = payload;
  },
  SET_TRAINER(state, payload) {
    state.trainer = payload;
  },
  ADD_TRAINER(state, payload) {
    state.trainer.push(payload);
  },
  UPDATE_TRAINER(state, payload) {
    state.trainer = _.unionBy([payload], state.trainer, "id_trainer");
  },
  DELETE_TRAINER(state, ids) {
    _.remove(state.trainer, function(trainer) {
      return ids.includes(trainer.id_trainer);
    });
    state.trainer = [...state.trainer];
  }
};

const actions = {
  GET_OPTIONS({ commit }) {
    commit("LOADING", null, { root: true });
    return Vue.axios.get(URL + "/options").then(res => {
      commit("trainer_divisi/SET_TRAINER_DIVISI", res.data.trainer_divisi, {
        root: true
      });
      commit("LOADING_DONE", null, { root: true });
    });
  },
  GET_TRAINER({ commit }) {
    commit("LOADING", null, { root: true });
    commit("LOADED", false);
    return Vue.axios.get(API_URL).then(res => {
      commit("INIT");
      commit("LOADED", true);
      commit("SET_TRAINER", res.data);
      commit("LOADING_DONE", null, { root: true });
    });
  },
  ADD_TRAINER({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .post(API_URL, qs.stringify(payload))
      .then(res => {
        commit("ADD_TRAINER", res.data);
        commit("SUCCESS", "Berhasil menambah...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  },
  UPDATE_TRAINER({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .put(API_URL + payload.id_trainer, qs.stringify(payload))
      .then(res => {
        commit("UPDATE_TRAINER", res.data);
        commit("SUCCESS", "Berhasil mengupdate...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  },
  DELETE_TRAINER({ commit }, payload) {
    let ids = payload.map(p => p.id_trainer).join(",");
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .delete(API_URL + ids)
      .then(res => {
        commit("DELETE_TRAINER", res.data.ids);
        if (typeof res.data.errors !== "undefined")
          commit("ERROR", res.data.errors, { root: true });
        else commit("SUCCESS", "Berhasil menghapus...", { root: true });
        return res.data.ids;
      })
      .catch(() => {
        commit("ERROR", "Data masih dipakai di tabel lain!", { root: true });
      });
  },
  MERGE_TRAINER({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .post(URL + "/merge/", qs.stringify(payload))
      .then(res => {
        commit("DELETE_TRAINER", res.data.ids);
        commit("UPDATE_TRAINER", res.data.destination);
        commit("SUCCESS", "Berhasil merge...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
